import React, { useState } from 'react';
import { getBrandfetchLogoUrl, getCompanyInitials } from '../utils/logoHelper';

interface CompanyLogoProps {
  siteUrl: string;
  className?: string;
}

/**
 * Composant qui affiche le logo d'une entreprise via Brandfetch CDN
 * Avec fallback sur les initiales si le logo n'est pas trouvé
 */
export const CompanyLogo: React.FC<CompanyLogoProps> = ({ siteUrl, className = '' }) => {
  const [error, setError] = useState(false);

  if (!siteUrl) {
    return null;
  }

  const logoUrl = getBrandfetchLogoUrl(siteUrl);
  const initials = getCompanyInitials(siteUrl);

  // Si erreur de chargement, afficher les initiales
  if (error) {
    return (
      <div className={`flex justify-center ${className}`}>
        <div className="flex items-center justify-center h-20 w-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg text-white text-2xl font-bold shadow-lg">
          {initials}
        </div>
      </div>
    );
  }

  // Afficher le logo Brandfetch
  return (
    <div className={`flex justify-center ${className}`}>
      <img
        src={logoUrl}
        alt="Logo de l'entreprise"
        className="h-20 w-auto max-w-[200px] object-contain transition-all duration-300"
        onError={() => setError(true)}
      />
    </div>
  );
};
